<template>
    <v-container>
        <v-row>
            <v-card
                class="mx-auto"
                style="overflow: auto !important;"
                
                height="400px"
            >
                <v-sheet class="pa-4 primary lighten-2">
                    <v-text-field
                        v-model="search"
                        label="Search Bmos"
                        dark
                        flat
                        solo-inverted
                        hide-details
                        clearable
                        clear-icon="mdi-close-circle-outline"
                        @keyup.enter="handleEnterKeyPress"
                    ></v-text-field>
                </v-sheet>
                <v-card-text class="ma-0 pa-0">
                    <VTreeview  style="width:800px;"
                        dense
                        :items="search_results"
                        item-key="unique_id"
                        selection-type="leaf"
                        v-model="selection"
                        selectable
                        return-object
                        @input="onUpdate"
                        @update:open="onOpen"
                    >
                    </VTreeview>
                </v-card-text>
            </v-card>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import axios from 'axios';

enum TreeItemType {
  TreeTypeChild = 1,
  TreeTypeParent,
}


interface ISensor {
    bcp_id: number;
    name: string;
    subarea_id: number;
    bmos_id: number;
}

interface ITreeObject {
    id: string;
    name: string;
    children: [];
}

export interface IBmosSensor {
    bmos_id: string;
    name: string;
}

function escapeDoubleQuotes(str: string) {
    return str.replace(/\\([\s\S])|(")/g, '\\$1$2');
}

@Component({
    components: {},
})
export default class SensorsChoice extends Vue {
    @Prop() public msg!: string;

    private search: string = '';

    // private filter: string = '';

    private selection: ITreeObject[] = [];

    private search2: string = '';

    private items = [];
    private search_results: any[] = [];

    private prevent_update: boolean = false;

    // private selected_subarea: number = -1;
    // private selected_building: number = -1;
    // private selected_site: number = -1;
    private selected_sensors: ISensor[] = [];
    private all_sensors: ISensor[] = [];
    private all_bmos_sensors: IBmosSensor[] = [];

    // public get filter2() {
    //     return this.search2.startsWith('@') ? (item: any, search: string, textKey: string) => item['id'].indexOf(search.substring(1)) > -1 : undefined;
    // }

    // public getAllIdsInHierarchy(item: any): string[] {
    //     const ids = [item.id];

    //     if (item.children && item.children.length > 0) {
    //         for (const child of item.children) {
    //         const childIds = this.getAllIdsInHierarchy(child);
    //         ids.push(...childIds);
    //         }
    //     }

    //     return ids;
    // }

    // public arrayIntersection(arr1: string[], arr2: string[]): string[] {
    //     return arr1.filter(value => arr2.includes(value));
    //     }

    // public get filter2() {
    //     return (item: any, search: string, textKey: string) => {
    //         search = 'sn218';
    //         this.search_results = this.searchItems([item], search.toLowerCase());
    //         console.log(`item: ${item.name} (${item.id}), search_results:`, this.search_results);
    //         //const allIds = this.getAllIdsInHierarchy(item);
    //         //console.log("allIds:", allIds);

    //         //const intersection: string[] = this.arrayIntersection(allIds, this.search_results);

    //         //let include_result = this.search_results.includes(item.id);
    //         //console.log("intersection:", intersection);
    //         let include_result = this.search_results.includes(item.id);

    //         if (!include_result) {
    //             return true;
    //         }

    //         return false;
    //     };
    // }

    public handleEnterKeyPress() {

        // self.search_results = self.items

        // Handle logic for Enter key press
        this.search_results = this.searchItems(this.items, this.search.toLowerCase());

        console.log("search_results", this.search_results);

        console.log('Enter key pressed. Do something here.');
    }

    public searchItems(items: any[], search: string, parents: any[] = []): any[] {
        const filtered = [];

        for (const item of items) {
            const lowerName = item.name.toLowerCase();

            if (item.children && item.children.length > 0) {
            const matchingChildren = this.searchItems(item.children, search, [...parents, item]);

            if (matchingChildren.length > 0 || lowerName.includes(search)) {
                // Include the current item with filtered children
                const newItem = { ...item, children: matchingChildren };
                filtered.push(newItem);
            }
            } else if (lowerName.includes(search)) {
            // Include leaf nodes that match the search string
            filtered.push(item);
            }
        }

        return filtered;
    }

    // public searchItems(items: any[], search: String, parents: any[] = []): String[] {
    //     const filtered = [];

    //     for (const item of items) {
    //         const lowerName = item.name.toLowerCase();

    //         if (item.children && item.children.length > 0) {
    //         const matchingChildren = this.searchItems(item.children, search, [...parents, item]);

    //         if (matchingChildren.length > 0 || lowerName.includes(search)) {
    //             // Push the id of the current item
    //             filtered.push(item);

    //             // Push the ids of the filtered children
    //             filtered.push(...matchingChildren);
    //         }
    //         } else if (lowerName.includes(search)) {
    //             // Include leaf nodes that match the search string

    //             // Push the id of the current item
    //             filtered.push(item);
    //         }
    //     }

    //     return filtered;
    // }

    // curl -X POST https://bmos.carnegosystems.net/read_tree -H "authorization: BEARER authToken=PKLivoIgkH390hiKHOAutagi2Emfd5"
    public getSensorsTree(filter?: string) {
        const self = this;

        self.all_bmos_sensors = [];

        const headers = self.$store.getters.DefaultHeaders;

        const zinc = 'ver:"3.0" action:"tree"\n';

        return axios
            .post(window.VUE_BMOS_WEB_API + '/action', zinc, headers)
            .then((response) => {
                if (response.data !== undefined && response.data !== null) {
                    // const payload = JSON.parse(response.data);
                    // self.items = self.items;

                    // self.items = payload['items'];

                    self.items = response.data['items'];
                    self.search_results = self.items;

                   // this.search_results = this.searchItems(this.items, "sn218");

                    //console.log("this.search_results", this.search_results);
                }

                return false;
            })
            .catch((error) => {
                console.log(error);
                if (error.response) {
                    console.log(error.response.data);
                    return false;
                }
            });
    }

    private onOpen(event: ITreeObject[]) {
        const self = this;
    }

    private onUpdate(event: ITreeObject[]) {
        const self = this;

        const bmos_ids: IBmosSensor[] = this.selection.map((x: ITreeObject) => ({bmos_id: '@' + x.id.split('_')[1], name: x.name }));
        // self.$store.dispatch('setBmosIds', bmos_ids);
        this.$emit('setBmosIds', bmos_ids);
    }

    private mounted() {

        const self = this;

        self.getSensorsTree();

        self.$store.watch(
            (state) => {
                return this.$store.state.currentSiteGroup; // Does not seem to work with Getter
            },
            (newValue, oldValue) => {

                self.getSensorsTree();
            },
                // Optional Deep if you need it
                {
                deep: true,
                },
        );

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.scroll {
    overflow-x: auto;
    overflow-y: scroll;
}

// .button.v-treeview-node__toggle + button.v-treeview-node__checkbox {
//  display: none !important;
// }

</style>
